module.exports = __webpack_public_path__ + "static/media/Rottemplate3.a314b62c.jpg";